export default {
  admin: {
    products: {
      holdingData: {
        deleteDataSingleDate: {
          button: "Elimina",
          deleteSuccessText: "Dati delle posizioni eliminati con successo.",
          prompt: {
            delete: "Elimina",
            text: (ctx) =>
              `Stai per eliminare definitivamente i dati delle posizioni per il ${ctx.named("date")}. Se sei sicuro, clicca sul pulsante qui sotto per confermare.`,
            title: "Elimina dati posizioni",
          },
        },
        deletePropertyMetadata: {
          deleteSuccessText: "Proprietà eliminata con successo.",
          prompt: {
            cancel: "Annulla",
            delete: "Elimina",
            deleteForDate: (ctx) => `Per la data ${ctx.named("selectedDate")}`,
            deleteGlobally: "Globalmente",
            text: (ctx) =>
              `Stai per eliminare la proprietà "${ctx.named("propertyToDelete")}". Vuoi eliminarla globalmente o solo per questa data?`,
            title: "Elimina proprietà",
          },
        },
        enrichDataSingleDate: {
          button: "Arricchisci da CSV",
          enrichSuccessText: "Dati delle posizioni arricchiti con successo.",
          emptyCsv: "Nulla da importare — il CSV è vuoto.",
          noPropertyToEnrich:
            "Non è stata trovata alcuna proprietà definita dall'utente per arricchire i dati correnti.",
          enrichPrompt: {
            cancel: "Annulla",
            condition1:
              "Il file deve includere una riga di intestazione con almeno: 'Holding name', 'Isin', 'Currency', e una proprietà aggiuntiva definita dall'utente.",
            condition2:
              "Ogni riga deve avere una combinazione unica di 'Holding name', 'Isin' e 'Currency'.",
            condition3:
              "Ogni combinazione di 'Holding name', 'Isin' e 'Currency' per la data target deve apparire esattamente una volta nel CSV.",
            enrich: "Arricchisci",
            text: "Carica un file CSV per arricchire i dati delle posizioni. Devono essere soddisfatte le seguenti condizioni:",
            title: "Arricchisci dati posizioni",
          },
          enrichNewPropertyPrompt: {
            cancel: "Annulla",
            enrich: "Arricchisci",
            isCategorical: "Categoriale",
            isCategoricalTooltip:
              "Le proprietà categoriali permettono di raggruppare le posizioni e visualizzarle in sezioni come 'Panoramica' e 'Scheda informativa' (Factsheet), sia in una data specifica che nel tempo. Queste proprietà possono essere tradotte nella sezione Regolazione Dati Posizioni. Se una proprietà categoriale viene generata automaticamente (non definita dall'utente), può anche essere sovrascritta in quella sezione.",
            isFfill: "Riempimento in avanti (Forward filled)",
            isFfillTooltip:
              "Quando non è disponibile alcun valore per una data selezionata, verrà utilizzato il valore precedente più recente.",
            newProperty: "Nuova proprietà",
            text: "Questo arricchimento creerà nuove proprietà. Si prega di rivedere le proprietà proposte e definire le loro impostazioni predefinite. Nota: anche differenze minori nei nomi delle proprietà (es. maiuscole/minuscole) comporteranno la creazione di nuove proprietà.",
            title: "Rilevate nuove proprietà",
          },
          enrichErrorPrompt: {
            close: "Chiudi",
            selectErrorType: "Seleziona tipo di errore:",
            title: "Errori di arricchimento",
            columns: {
              currency: "Valuta",
              firstRow: "Prima riga",
              holdingName: "Nome posizione",
              isin: "ISIN",
              rowIndex: "Indice riga",
            },
            duplicatedHeader: {
              header: "Intestazioni duplicate:",
              title: "Intestazione duplicata",
              text: "Il tuo CSV contiene intestazioni di colonna duplicate. Rinominale in modo che ogni intestazione sia unica.",
            },
            emptyHeader: {
              title: "Intestazione vuota",
              text: "Il tuo CSV contiene intestazioni di colonna vuote. Assegna un nome a ciascuna colonna utilizzando almeno un carattere non vuoto.",
            },
            mismatchedColumn: {
              missingExpectedColumns: "Colonne richieste mancanti:",
              title: "Discrepanza colonne",
              text: "Assicurati che l'intestazione del CSV includa (case-sensitive): Holding name, Isin, Currency.",
            },
            duplicatedConstituent: {
              title: "Componente duplicato",
              text: "Rimuovi le voci duplicate per lo stesso componente.",
            },
            missingConstituent: {
              title: "Componente mancante",
              text: "Aggiungi i componenti mancanti affinché il CSV copra interamente la data selezionata.",
            },
            papaparseMissingQuotes: {
              title: "Virgolette non chiuse",
              text: "L'analisi del CSV è fallita perché una stringa tra virgolette non è stata chiusa correttamente. Controlla le virgolette di chiusura mancanti nei tuoi dati.",
            },
            papaparseUndetectableDelimiter: {
              title: "Delimitatore non rilevabile",
              text: "L'analisi del CSV è fallita. Nessun delimitatore comune è stato rilevato. Assicurati che il file utilizzi coerentemente un unico delimitatore, tipicamente una virgola o un punto e virgola.",
            },
            papaparseTooFewFields: {
              title: "Campi insufficienti",
              text: "L'analisi del CSV è fallita. Ogni riga dovrebbe avere lo stesso numero di colonne delle intestazioni. Attualmente, alcune righe hanno meno colonne del previsto. Controlla la struttura del tuo file.",
            },
            papaparseTooManyFields: {
              title: "Troppi campi",
              text: "L'analisi del CSV è fallita. Ogni riga dovrebbe avere lo stesso numero di colonne delle intestazioni. Attualmente, alcune righe hanno più colonne del previsto. Controlla la struttura del tuo file.",
            },
          },
        },
        exportDataSingleDate: {
          button: "Esporta come CSV",
        },
        importDataSingleDate: {
          button: "Importa da CSV",
          emptyCsv: "Nulla da importare — il CSV è vuoto.",
          importSuccessText: "Dati delle posizioni importati con successo.",
          importPrompt: {
            cancel: "Annulla",
            condition1:
              "Il file deve includere una riga di intestazione con almeno: 'Holding name', 'Isin', 'Currency', 'value', e 'weight'.",
            condition2:
              "Ogni riga deve avere una combinazione unica di 'Holding name', 'Isin' e 'Currency'.",
            condition3:
              "Ogni 'value' e 'weight' deve essere un numero in formato standard (punto come separatore decimale, nessun separatore delle migliaia).",
            date: "Data",
            import: "Importa",
            text: "Carica un CSV per importare i dati delle posizioni. Devono essere soddisfatte le seguenti condizioni:",
            title: "Importa dati posizioni",
          },
          importNewPropertyPrompt: {
            cancel: "Annulla",
            import: "Importa",
            isCategorical: "Categoriale",
            isCategoricalTooltip:
              "Le proprietà categoriali permettono di raggruppare le posizioni e visualizzarle in sezioni come 'Panoramica' e 'Scheda informativa', sia in una data specifica che nel tempo. Queste proprietà possono essere tradotte nella sezione Regolazione Dati Posizioni. Se una proprietà categoriale viene generata automaticamente (non definita dall'utente), può anche essere sovrascritta in quella sezione.",
            isFfill: "Riempimento in avanti (Forward filled)",
            isFfillTooltip:
              "Quando non è disponibile alcun valore per una data selezionata, verrà utilizzato il valore precedente più recente.",
            newProperty: "Nuova proprietà",
            text: "Questa importazione creerà nuove proprietà. Si prega di rivedere le proprietà proposte e definire le loro impostazioni predefinite. Nota: anche differenze minori nei nomi delle proprietà (es. maiuscole/minuscole) comporteranno la creazione di nuove proprietà.",
            title: "Rilevate nuove proprietà",
          },
          importErrorsPrompt: {
            close: "Chiudi",
            selectErrorType: "Seleziona tipo di errore:",
            title: "Errori di importazione",
            columns: {
              currency: "Valuta",
              firstRow: "Prima riga",
              holdingName: "Nome posizione",
              isin: "ISIN",
              rowIndex: "Indice riga",
            },
            duplicatedHeader: {
              header: "Intestazioni duplicate:",
              title: "Intestazione duplicata",
              text: "Il tuo CSV contiene intestazioni di colonna duplicate. Rinominale in modo che ogni intestazione sia unica.",
            },
            emptyHeader: {
              title: "Intestazione vuota",
              text: "Il tuo CSV contiene intestazioni di colonna vuote. Assegna un nome a ciascuna colonna utilizzando almeno un carattere non vuoto.",
            },
            mismatchedColumn: {
              missingExpectedColumns: "Colonne richieste mancanti:",
              title: "Discrepanza colonne",
              text: "Assicurati che l'intestazione del CSV includa (case-sensitive): Holding name, Isin, Currency, value, weight.",
            },
            duplicatedConstituent: {
              title: "Componente duplicato",
              text: "Rimuovi le voci duplicate per lo stesso componente.",
            },
            missingValue: {
              title: "Valore mancante",
              text: "Alcune righe non hanno un valore. Assicurati che ogni riga abbia un valore numerico correttamente formattato.",
            },
            invalidValueFormat: {
              title: "Formato valore non valido",
              text: "Impossibile dedurre il formato del valore. Usa il punto come separatore decimale e nessun separatore delle migliaia.",
            },
            missingWeight: {
              title: "Peso mancante",
              text: "Alcune righe non hanno un peso. Assicurati che ogni riga abbia un peso numerico correttamente formattato.",
            },
            invalidWeightFormat: {
              title: "Formato peso non valido",
              text: "Impossibile dedurre il formato del peso. Usa il punto come separatore decimale e nessun separatore delle migliaia.",
            },
            papaparseMissingQuotes: {
              title: "Virgolette non chiuse",
              text: "L'analisi del CSV è fallita perché una stringa tra virgolette non è stata chiusa correttamente. Controlla le virgolette di chiusura mancanti nei tuoi dati.",
            },
            papaparseUndetectableDelimiter: {
              title: "Delimitatore non rilevabile",
              text: "L'analisi del CSV è fallita. Nessun delimitatore comune è stato rilevato. Assicurati che il file utilizzi coerentemente un unico delimitatore, tipicamente una virgola o un punto e virgola.",
            },
            papaparseTooFewFields: {
              title: "Campi insufficienti",
              text: "L'analisi del CSV è fallita. Ogni riga dovrebbe avere lo stesso numero di colonne delle intestazioni. Attualmente, alcune righe hanno meno colonne del previsto. Controlla la struttura del tuo file.",
            },
            papaparseTooManyFields: {
              title: "Troppi campi",
              text: "L'analisi del CSV è fallita. Ogni riga dovrebbe avere lo stesso numero di colonne delle intestazioni. Attualmente, alcune righe hanno più colonne del previsto. Controlla la struttura del tuo file.",
            },
          },
        },
        updatePropertyMetadata: {
          saveSuccessText: "Proprietà aggiornata con successo.",
          unsavedChangesAlert: "Hai modifiche non salvate. Uscendo ora verranno perse.",
          prompt: {
            isCategorical: "Categoriale",
            isCategoricalTooltip:
              "Le proprietà categoriali permettono di raggruppare le posizioni e visualizzarle in sezioni come 'Panoramica' e 'Scheda informativa', sia in una data specifica che nel tempo. Queste proprietà possono essere tradotte nella sezione Regolazione Dati Posizioni. Se una proprietà categoriale viene generata automaticamente (non definita dall'utente), può anche essere sovrascritta in quella sezione.",
            isFfill: "Riempimento in avanti (Forward filled)",
            isFfillTooltip:
              "Quando non è disponibile alcun valore per una data selezionata, verrà utilizzato il valore precedente più recente.",
            propertyForUrl: "Proprietà URL",
            propertyForUrlTooltip:
              "Specifica il nome della proprietà contenente l'URL. Il valore della proprietà corrente verrà utilizzato come testo cliccabile.",
            title: "Aggiorna proprietà",
            translation: "Traduzione",
          },
        },
      },
    },
  },
  auth: {
    resetPasswordLink: {
      forgotPassword: "Hai dimenticato la password?",
    },
  },
  cards: {
    needLoginCard: {
      needLogged: "Devi effettuare l'accesso per vedere questo contenuto.",
    },
  },
  compliance: {
    cookies: {
      buttonText: "Accetta",
      cookiesUsage:
        "Questo sito utilizza i cookie per migliorare l'usabilità. Utilizzando questo sito web, acconsenti all'uso dei cookie e accetti la politica sulla privacy dove puoi trovare ulteriori informazioni sui cookie. Link: {0}.",
      privacyPolicy: "Politica sulla privacy",
    },
  },
  components: {
    biggestDrawdownsTable: {
      rank: "Rango",
      startDate: "Data di inizio",
      troughDate: "Data di minimo",
      recoveryDate: "Data di ripresa",
    },
    stressTestScenariosTable: {
      scenario: "Scenario",
      period: "Periodo",
      scenarioExtremelyBad: "Estremamente sfavorevole",
      scenarioUnfavourable: "Sfavorevole",
      scenarioModerate: "Moderato",
      scenarioFavourable: "Favorevole",
    },
    liquidityRiskScenarioTable: {
      timeToLiquidate: "Tempo di liquidazione",
      timeBucket1Day: "0-1 giorno",
      timeBucket2To7Days: "2-7 giorni",
      timeBucket8To30Days: "8-30 giorni",
      timeBucket31To90Days: "31-90 giorni",
      timeBucket91To180Days: "91-180 giorni",
      timeBucket181To365Days: "181-365 giorni",
      timeBucketMoreThan365Days: ">365 giorni",
      waterfallCumulativeWeight: "Cascata peso cumulativo",
      proRataCumulativeWeight: "Pro-rata peso cumulativo",
      nearProportionalCumulativeWeight: "Quasi proporzionale peso cumulativo",
    },
    details: {
      report: {
        aumFormat: (ctx) =>
          `${ctx.named("currency")} ${ctx.named("aumFormatted")} milion${ctx.named("aum") > 1000000 ? "i" : "e"}${
            ctx.named("asOfDate") ? ` (al ${ctx.named("asOfDate")})` : ""
          }`,
        lastPrice: (ctx) => `${ctx.named("currency")} ${ctx.named("lastPrice")}`,
      },
      overview: {
        aumFormat: (ctx) =>
          `${ctx.named("currency")} ${ctx.named("aumFormatted")} milion${ctx.named("aum") > 1000000 ? "i" : "e"} (al ${ctx.named("asOfDate")})`,
        lastPrice: (ctx) =>
          `${ctx.named("currency")} ${ctx.named("lastPrice")} (al ${ctx.named("asOfDate")})`,
      },
    },
    returnsVarGraph: {
      dailyReturn: "Rendimento giornaliero",
      twoWeekReturn: "Rendimento 2 settimane",
      monthlyReturn: "Rendimento mensile",
      oneDayOnePercent: "VaR 1 giorno (99%)",
      oneDayFivePercent: "VaR 1 giorno (95%)",
      twoWeeksOnePercent: "VaR 2 settimane (99%)",
      twoWeeksFivePercent: "VaR 2 settimane (95%)",
      oneMonthOnePercent: "VaR 1 mese (99%)",
      oneMonthFivePercent: "VaR 1 mese (95%)",
    },
    download: {
      tooltip: "Scarica come immagine",
      prompt: {
        downloadPngButton: "Scarica come PNG",
        downloadSvgButton: "Scarica come SVG",
        text: "Scegli in quale formato scaricare il componente.",
        title: "Scarica componente",
      },
    },
    portfolioBreakdownOnDate: {
      noDataYet: "Questo componente non ha ancora dati.",
    },
    portfolioBreakdownOverTime: {
      noDataYet: "Questo componente non ha ancora abbastanza dati.",
    },
    statisticsWithPeriods: {
      noStatisticsToDisplay: "Nessuna statistica da visualizzare.",
    },
    statistics: {
      noStatisticsToDisplay: "Nessuna statistica da visualizzare.",
    },
    operations: {
      statuses: {
        failed: "Fallito",
        pending: "In attesa",
        running: "In esecuzione",
        succeeded: "Riuscito",
      },
    },
  },
  datePickers: {
    datePicker: {
      selectDateTooltip: "Seleziona una data",
    },
    dateRangePicker: {
      from: "Da (aaaa-mm-gg)",
      fullPeriod: "Periodo intero",
      to: "A (aaaa-mm-gg)",
    },
    zoomPicker: {
      fiveYears: "5A",
      fullPeriod: "MAX",
      oneMonth: "1M",
      oneYear: "1A",
      sevenYears: "7A",
      sixMonths: "6M",
      threeMonths: "3M",
      tenYears: "10A",
      threeYears: "3A",
      twoYears: "2A",
      ytd: "YTD",
    },
  },
  dropdowns: {
    iconsDropdown: {
      noIcon: "Nessuna icona",
    },
  },
  editPrompt: {
    copyInAllLangs: "Copia in tutte le lingue",
    editField: "Modifica campo",
    enterText: "Inserisci un testo",
    overwriteDataAllShareClasses: "Sovrascrivi dati di tutte le classi di quote",
    propertyFilters: {
      title: "Filtri per proprietà",
      tooltip:
        "Per essere presa in considerazione, una posizione deve superare tutti i filtri applicati. Una posizione supera un filtro se corrisponde a uno qualsiasi dei suoi valori selezionati.",
      property: "Proprietà",
      values: "Valori",
      empty: "Nessun filtro per proprietà al momento.",
      add: "Aggiungi filtro per proprietà",
      multiSelect: {
        placeholder: "Seleziona valori",
        selectLabel: "Premi invio per selezionare",
        deselectLabel: "Premi invio per rimuovere",
        selectedLabel: "Selezionato",
        limitText: (ctx) => `e altri ${ctx.named("count")}`,
      },
    },
    id: "ID",
    idTooltip:
      "Questo identificatore univoco serve come riferimento per il componente all'interno della piattaforma. Ogni componente che crei necessita di un identificatore distinto. Raccomandiamo la seguente convenzione per una migliore leggibilità: usa il titolo del componente, convertilo in minuscolo, sostituisci gli spazi con trattini. Per un componente intitolato 'La Mia Tabella Analitica', l'identificatore sarebbe 'la-mia-tabella-analitica'.",
    needUniqueId:
      "L'identificatore fornito è attualmente in uso da un altro componente nella posizione attuale o in una collegata. Si prega di fornire un identificatore distintivo per garantirne l'unicità.",
    numberOfDecimals: "Numero di decimali",
    numberOfDecimalsTooltip:
      "Il numero di decimali per tutti i numeri visualizzati nel componente. Nota che questo non include gli assi dei grafici.",
    withBenchmark: "Mostra con il benchmark",
    resamplingStrategy: "Strategia di ricampionamento",
    windowHorizon: "Finestra mobile",
    windowHorizonTooltip:
      "La finestra mobile determina il periodo di 'look-back' utilizzato per calcolare la volatilità annualizzata in ogni punto del grafico. Un orizzonte più corto (ad es. 3 mesi) rende il grafico molto sensibile a shock di mercato e repentini cambiamenti di regime, anche se può sembrare 'rumoroso' a causa di fluttuazioni temporanee. Al contrario, un orizzonte più lungo (ad es. 1 anno) offre una vista più liscia e stabile dei rischi a lungo termine, eliminando il rumore di breve termine del mercato, anche se reagisce più lentamente a eventi correnti. Nota che scegliere un orizzonte più lungo comporta anche un'inizio più tardivo sul grafico, poiché il calcolo richiede un periodo storico completo prima che il primo valore possa essere tracciato.",
    windowHorizonOptions: {
      threeMonths: "3 mesi",
      sixMonths: "6 mesi",
      oneYear: "1 anno",
      twoYears: "2 anni",
      threeYears: "3 anni",
      fiveYears: "5 anni",
      sevenYears: "7 anni",
      tenYears: "10 anni",
    },
    timeWindow: "Finestra temporale",
    timeWindowOptions: {
      threeMonths: "3 mesi",
      sixMonths: "6 mesi",
      oneYear: "1 anno",
      twoYears: "2 anni",
      threeYears: "3 anni",
      fourYears: "4 anni",
      fiveYears: "5 anni",
      sixYears: "6 anni",
      sevenYears: "7 anni",
      eightYears: "8 anni",
      nineYears: "9 anni",
      tenYears: "10 anni",
      all: "Tutto",
    },
    valueAtRisk: "Value at risk",
    valueAtRiskOptions: {
      oneDayOnePercent: "VaR 1 giorno (99%)",
      oneDayFivePercent: "VaR 1 giorno (95%)",
      twoWeeksOnePercent: "VaR 2 settimane (99%)",
      twoWeeksFivePercent: "VaR 2 settimane (95%)",
      oneMonthOnePercent: "VaR 1 mese (99%)",
      oneMonthFivePercent: "VaR 1 mese (95%)",
    },
    footnote: "Testo sotto il componente",
    placeholderFootnote: "Un testo che appare sotto il componente. Es. 'Commissioni incluse.'",
    langTabError: "Alcuni campi non sono validi nelle seguenti lingue:",
    settingsOnlyUsedOnOverviewTooltip:
      "Questa impostazione influisce esclusivamente sulla vista 'Panoramica'.",
    startDate: "Data di inizio",
    startDateTooltip:
      "Seleziona una data di inizio (in formato AAAA-MM-GG) per il componente. Il componente si adatterà automaticamente per mostrare i dati a partire dalla prima data disponibile per il prodotto o dalla data scelta, a seconda di quale sia successiva. Lasciare questo campo vuoto mostrerà tutti i dati di prezzo disponibili per il prodotto.",
    tabError: "Alcuni campi non sono validi",
    title: "Titolo",
    titleEdit: (ctx) => `Modifica ${ctx.named("componentId")}`,
    titleAdd: "Aggiungi componente",
    unsavedChangesAlert: "Hai modifiche non salvate. Se esci senza salvare, andranno perse.",
    resamplingStrategyOptions: {
      standard: "Standard",
      standardTooltip:
        "Regola automaticamente il livello di dettaglio in base all'intervallo temporale selezionato per mantenere il grafico chiaro e leggibile.",
      monthly: "Mensile",
      monthlyTooltip: "Mostra l'ultimo valore registrato per ogni mese nel periodo selezionato.",
    },
    reportFooter: {
      saveSuccess: "Il piè di pagina è stato aggiornato con successo.",
      title: "Piè di pagina",
      text: "Testo",
      showPageNumber: "Mostra numero di pagina",
      showFooterLine: "Mostra linea piè di pagina",
      margins: {
        bottom: "Inferiore",
        left: "Sinistro",
        right: "Destro",
        title: "Margini (mm)",
      },
    },
    reportHeader: {
      backgroundImage: "Immagine di sfondo",
      backgroundImageTooltip:
        "Le dimensioni dell'intestazione sono 794 pixel per la larghezza e qualunque sia scelta per l'altezza (vedi sotto), quindi usa un'immagine con dimensioni che seguano lo stesso rapporto per il miglior risultato.",
      logo: "Logo",
      saveSuccess: "L'intestazione è stata aggiornata con successo.",
      showDateRange: "Mostra intervallo date",
      textInPrimary: "Testo nel colore del brand",
      text: "Testo",
      title: "Intestazione",
      useCompanyLogo: "Usa logo aziendale",
      logoPosition: {
        left: "Sinistra",
        right: "Destra",
        title: "Posizione logo",
      },
      datePosition: {
        bottomLeft: "In basso a sinistra",
        bottomRight: "In basso a destra",
        centerLeft: "Al centro a sinistra",
        centerRight: "Al centro a destra",
        hidden: "Nascosto",
        title: "Posizione data",
        topLeft: "In alto a sinistra",
        topRight: "In alto a destra",
      },
      headerVisibility: {
        allPages: "Tutte le pagine",
        hidden: "Nascosto",
        onlyFirstPage: "Solo sulla prima pagina",
        title: "Visibilità intestazione",
      },
      height: {
        title: "Altezza",
        large: "Grande (200 px / ~52,90 mm)",
        normal: "Normale (150 px / ~39,67 mm)",
        small: "Piccola (100 px / ~26,45 mm)",
        veryLarge: "Molto grande (250 px / ~66,12 mm)",
      },
      margins: {
        bottom: "Inferiore",
        left: "Sinistro",
        right: "Destro",
        top: "Superiore",
        title: "Margini (mm)",
        tooltip: "I margini non influiscono sull'immagine di sfondo.",
      },
      productNamePosition: {
        bottomLeft: "In basso a sinistra",
        bottomRight: "In basso a destra",
        centerLeft: "Al centro a sinistra",
        centerRight: "Al centro a destra",
        hidden: "Nascosto",
        title: "Posizione nome prodotto",
        topLeft: "In alto a sinistra",
        topRight: "In alto a destra",
      },
      textPosition: {
        bottomLeft: "In basso a sinistra",
        bottomRight: "In basso a destra",
        centerLeft: "Al centro a sinistra",
        centerRight: "Al centro a destra",
        title: "Posizione testo",
        topLeft: "In alto a sinistra",
        topRight: "In alto a destra",
      },
    },
    reportStyle: {
      primaryColor: "Colore primario",
      colorSchemePicker: "Selettore schema colori",
      colorSchemeTooltip:
        "Questo schema di colori si applica attualmente ai grafici a torta e a ciambella. Se non vengono forniti colori, i grafici useranno lo schema colori generale della piattaforma.",
      saveSuccess: "Lo stile è stato aggiornato con successo.",
      title: "Stile",
      fontSize: {
        normal: "Normale",
        large: "Grande",
        small: "Piccolo",
        title: "Dimensione font",
      },
      margins: {
        left: "Sinistro",
        right: "Destro",
        title: "Margini (mm)",
      },
      spacing: {
        comfortable: "Comodo",
        compact: "Compatto",
        title: "Spaziatura",
      },
      titleBorder: {
        above: "Sopra il titolo",
        below: "Sotto il titolo",
        none: "Nessun bordo",
        title: "Bordo titolo",
      },
      titlesBold: {
        title: "Titoli dei componenti in grassetto",
      },
    },
    genericComponent: {
      addColumn: "Aggiungi colonna",
      addRow: "Aggiungi riga",
      addData: "Aggiungi dati",
      cantChangeType:
        "Non puoi cambiare il tipo di un componente generico una volta salvato. Se vuoi un tipo diverso, devi creare un nuovo componente generico.",
      columnWithIndex: (ctx) => `Colonna ${ctx.named("idx")}`,
      data: "Dati",
      date: "Data",
      displayValuesAsPerc: "Mostra valori come percentuale",
      displayValuesAsPercTooltip: "Mostra i valori con un simbolo '%' nel grafico.",
      donutChart: "Grafico a ciambella",
      exampleSector: "Es., Settori",
      header: "Intestazione",
      horizontalBarChart: "Grafico a barre orizzontali",
      key: "Chiave",
      image: "Immagine",
      lineChart: "Grafico lineare",
      needData:
        "Non puoi salvare un componente generico senza dati o con dati parziali. Eliminalo, aggiungi dati o completa i dati presenti prima di salvare.",
      pieChart: "Grafico a torta",
      removeData: "Rimuovi dati",
      showColumnHeader: "Mostra intestazione colonna",
      table: "Tabella",
      text: "Testo",
      type: "Tipo",
      value: "Valore",
      verticalBarChart: "Grafico a barre verticali",
      video: "Video",
      weightPercent: "Peso (in %)",
      lineChartSection: {
        fileMust: "Il tuo file deve:",
        selectFile: "Seleziona un file",
        uploadCsv: "Carica un file CSV contenente i dati delle tue serie storiche.",
        conditions: {
          dateFormat: "Usare il formato data <strong>AAAA-MM-GG</strong>.",
          dateIncreaseAndUnique: "Contenere date che siano strettamente crescenti e uniche.",
          headerRow:
            "Includere una riga di intestazione con le colonne <code>date</code> e <code>value</code>.",
          maxPoints:
            "Avere un massimo di <strong>500 righe</strong> e una dimensione file inferiore a <strong>1&nbsp;MB</strong>.",
          numberFormat:
            "Usare un punto (.) come separatore decimale e non includere alcun separatore delle migliaia.",
        },
        errors: {
          exceedSize: {
            title: "File troppo grande",
            text: "Il file caricato supera 1&nbsp;MB. Si prega di limitarlo a un massimo di 500 punti dati.",
          },
          invalidData: {
            title: "Dati non validi rilevati",
            text: "Alcune righe contengono valori mancanti o non validi. Assicurati che la colonna <code>date</code> usi il formato <strong>AAAA-MM-GG</strong> e la colonna <code>value</code> contenga numeri validi.",
          },
          invalidDataSequence: {
            title: "Sequenza date non valida",
            text: "Le date devono essere strettamente crescenti e uniche. Correggi il file e riprova.",
          },
          parseFail: {
            title: "Analisi fallita",
            text: "Il file CSV non è stato letto correttamente. Verifica il formato e riprova. Se il problema persiste, contatta il team Alquant.",
          },
          tooManyDataPoints: {
            title: "Troppi punti dati",
            text: "Il tuo file contiene più di 500 righe. Si prega di ridurlo a 500 o meno prima di caricarlo.",
          },
          unexpectedError: {
            title: "Errore imprevisto",
            text: "Si è verificato un errore imprevisto durante l'elaborazione del file. Contatta il team Alquant per assistenza.",
          },
        },
      },
    },
    contacts: {
      addContact: "Aggiungi contatto",
      contacts: "Contatti",
      contactsPerRow: "Contatti per riga",
      additionalText: "Testo aggiuntivo",
      email: "Email",
      exampleEmail: "Es., mrossi@mail.com",
      exampleName: "Es., Mario Rossi",
      examplePhone: "Es., +41 79 123 45 67",
      exampleRole: "Es., Partner",
      image: "Immagine",
      name: "Nome",
      phone: "Telefono",
      removeContact: "Rimuovi contatto",
      role: "Ruolo",
    },
    dialog: {
      copyInAllLangs: {
        title: "Copia in tutte le lingue",
        text: "Stai per copiare tutti i valori della lingua corrente in tutte le altre lingue. Sei sicuro?",
      },
      saveFieldInAllShareClasses: {
        title: "Sovrascrivi",
        text: "Stai per sovrascrivere questo campo in tutte le altre classi di quote di questo prodotto, non solo nella classe corrente. Sei sicuro?",
      },
      saveInAllShareClasses: {
        title: "Sovrascrivi",
        text: (ctx) =>
          `Stai per sovrascrivere i dati "${ctx.named(
            "tabName"
          )}" di tutte le altre classi di quote di questo prodotto con i dati "${ctx.named(
            "tabName"
          )}" di questa classe (non solo le ultime modifiche apportate). Sei sicuro?`,
      },
    },
    description: {
      contentTitle: "Descrizione",
    },
    disclaimer: {
      contentTitle: "Disclaimer",
      defaultWarning:
        "Attualmente non hai un disclaimer per questo prodotto. Pertanto, è stato utilizzato il disclaimer standard. Se scrivi un disclaimer qui, verrà visualizzato solo per questo prodotto.",
    },
    historicalPricesChart: {
      adjusted: "Usa prezzi rettificati",
      adjustedTooltip:
        "Generalmente, per prezzi rettificati si intendono prezzi corretti per dividendi, frazionamenti e altri eventi. Il prezzo non rettificato si riferisce semplicemente al costo di una quota del prodotto alla fine della giornata.",
      defaultLogScale: "Di default in scala logaritmica",
      showLogScaleSwitch: "Mostra interruttore scala logaritmica",
      priceIndexedTo100: "Usa prezzi indicizzati a 100",
    },
    portfolioBreakdown: {
      cantChangeProperty:
        "Non puoi cambiare la proprietà di un componente posizioni una volta salvato. Se vuoi una proprietà diversa, devi creare un nuovo componente posizioni.",
      chartType: "Tipo di grafico",
      displayOrder: "Ordine di visualizzazione",
      donutChart: "Grafico a ciambella",
      horizontalBarChart: "Grafico a barre orizzontali",
      lagRule: "Regola di ritardo dati",
      lagRuleTooltip:
        "Scegli quanto ritardare i dati visualizzati in questo componente. Ad esempio, un ritardo di due fine mese significa mostrare i dati più recenti disponibili di due mesi prima, alla fine di quel mese. Se oggi è il 15 gennaio 2025, i dati mostrati sarebbero al 30 novembre 2024.",
      pieChart: "Grafico a torta",
      property: "Proprietà",
      table: "Tabella",
      verticalBarChart: "Grafico a barre verticali",
      onlyShowTopThenOthers: {
        title: "Mostra solo i primi",
        tooltip:
          'Mostra solo i primi X (numero scelto) e unisci i rimanenti in "Altri". Lascia vuoto per mostrare tutto.',
      },
      categoryIdsInOthers: {
        title: 'Elementi da considerare come "Altri"',
        multiSelect: {
          placeholder: "Seleziona elementi",
          selectLabel: "Premi invio per selezionare",
          deselectLabel: "Premi invio per rimuovere",
          selectedLabel: "Selezionato",
          limitText: (ctx) => `e altri ${ctx.named("count")}`,
        },
      },
      sortOptions: {
        alphabeticallyAscending: "Nome (A → Z)",
        alphabeticallyDescending: "Nome (Z → A)",
        weightAscending: "Peso (Basso → Alto)",
        weightDescending: "Peso (Alto → Basso)",
      },
      lagRuleOptions: {
        noLag: "Nessun ritardo (usa ultimi dati)",
        oneMonthEnd: "Dati fine mese precedente",
        twoMonthEnd: "Dati fine mese di due mesi fa",
      },
      normalizeBreakdownWeight: "Normalizza i pesi",
      normalizeBreakdownWeightTooltip:
        "Se abilitato, i pesi sono scalati in modo che la somma sia il 100 % su tutte le categorie nella data selezionata (o su ogni data della serie storica).",
    },
    keyCharacteristics: {
      addKeyCharacteristics: "Aggiungi caratteristiche chiave",
      exampleDynamicExposure: "Es., Esposizione dinamica",
      exampleWeDynamicallyAdapt: "Es., Adattiamo dinamicamente ...",
      header: "Intestazione",
      icon: "Icona",
      paragraph: "Paragrafo",
      removeKeyCharacteristics: "Rimuovi caratteristica chiave",
    },
    biggestDrawdownsTable: {
      numberOfDrawdowns: "Numero di drawdown",
    },
    stressTestScenariosTable: {
      product: "Prodotto",
      benchmark: "Benchmark",
      periods: "Periodi",
      addPeriod: "Aggiungi periodo",
      deletePeriod: "Elimina periodo",
    },
    liquidityAnalysisTable: {
      customizedTable: "Tabella di anteprima",
      holdingsToIgnore: {
        title: "Posizioni da ignorare",
        holdingsMultiselect: {
          placeholder: "Seleziona posizioni da ignorare",
          selectLabel: "Premi invio per selezionare",
          deselectLabel: "Premi invio per rimuovere",
          selectedLabel: "Selezionato",
          limitText: (ctx) => `e altre ${ctx.named("count")}`,
        },
      },
      holdingsToIgnoreContainText: {
        title: "Ignora le posizioni il cui nome contiene",
        placeholder: "es. Cassa, Altri",
      },
    },
    liquidityRiskScenarioTable: {
      rowsByTimeBucket: "Dati per tempo fino alla liquidazione",
      amountPlaceholder: "Importo (Mio)",
      weightPlaceholder: "Peso (%)",
    },
    monthlyReturnsTable: {
      descending: "Ordina anni in ordine decrescente",
      benchmark: "Benchmark",
      product: "Prodotto",
      return: "Rendimento",
      nameReplacements: "Sostituisci nomi predefiniti",
      nameReplacementsTooltip:
        "Personalizza i nomi del prodotto e del benchmark nel componente. Lascia vuoto per usare i nomi esistenti.",
    },
    notify: {
      componentSaveSuccess: (ctx) =>
        `Il componente '${ctx.named("componentId")}' è stato aggiornato con successo.`,
    },
    overviewHeader: {
      backgroundImage: "Immagine di sfondo",
      backgroundImageTooltip:
        "Tieni presente che l'immagine attualmente in considerazione viene utilizzata anche come immagine della scheda prodotto nella homepage. Di conseguenza, qualsiasi modifica a questa immagine influirà simultaneamente sulla rappresentazione del prodotto nella homepage.",
      hideProductName: "Nascondi nome prodotto",
      text: "Testo",
      textInPrimary: "Testo nel colore del brand",
      textTooltip:
        "Tieni presente che il testo attualmente in considerazione viene utilizzato anche come testo della scheda prodotto nella homepage. Di conseguenza, qualsiasi modifica a questo testo influirà simultaneamente sulla rappresentazione del prodotto nella homepage.",
      saveSuccess: "L'intestazione è stata aggiornata con successo.",
      showDownloadLastFactsheetButton:
        'Mostra il pulsante "@:components.extras.downloadLastFactsheet.downloadLastFactsheet"',
      showDownloadLastFactsheetButtonTooltip:
        'Affinché il pulsante sia visibile per un utente, un documento deve essere contrassegnato come "@:pages.products.documents.prompt.uploadFile.shouldConsiderLastFactsheet" nella sezione "Documenti", e deve essere disponibile nella lingua selezionata dell\'utente.',
      showFollowButton: "Mostra pulsante segui",
      title: "Modifica intestazione panoramica",
    },
    overviewStyle: {
      colorSchemePicker: "Selettore schema colori",
      colorSchemeTooltip:
        "Questo schema di colori si applica attualmente ai grafici a torta e a ciambella. Se non vengono forniti colori, i grafici useranno lo schema colori generale della piattaforma.",
      saveSuccess: "Lo stile è stato aggiornato con successo.",
      title: "Stile",
      titlesBold: {
        title: "Titoli dei componenti in grassetto",
      },
    },
    productDetails: {
      addDetail: "Aggiungi dettaglio",
      exampleIsin: "Es., ISIN",
      exampleLU: "Es., LU2220388479",
      key: "Chiave",
      noteDragAndDrop: "Nota: Trascina e rilascia le righe per riordinare i dettagli.",
      removeDetail: "Rimuovi dettaglio",
      showAgio: "Mostra aggio",
      showAuM: "Mostra AuM",
      showLastPrice: "Mostra ultimo prezzo",
      showIsin: "Mostra ISIN",
      showTer: "Mostra TER",
      value: "Valore",
    },
    relativePerformanceChart: {
      footnote: "Nota a piè di pagina",
      placeholderFootnote: "Un testo che appare sotto il grafico. Es. 'Commissioni incluse.'",
    },
    riskProfile: {
      level: "Livello di rischio",
    },
    shareClassesTable: {
      bloomberg: "Bloomberg",
      class: "Classe",
      column: "Colonna",
      columnsToShow: "Colonne da mostrare",
      showColumn: "Mostra colonna",
      defaultFootnote:
        "Perf. SI: i rendimenti per periodi dall'inizio superiori a un anno sono annualizzati, e non annualizzati se inferiori a un anno.",
      footnote: "Nota a piè di pagina",
      inceptionDate: "Data di lancio",
      isin: "ISIN",
      mgmtFee: "Comm. gestione",
      minInvestment: "Invest. min.",
      perfFee: "Comm. performance",
      ter: "TER",
      title: "Modifica tabella classi di quote",
    },
    statistics: {
      benchmark: "Benchmark",
      product: "Prodotto",
      nameReplacements: "Sostituisci nomi predefiniti",
      nameReplacementsTooltip:
        "Personalizza i nomi del prodotto e del benchmark nel componente. Lascia vuoto per usare i nomi esistenti. Ad esempio, usa un termine come 'Prodotto' per abbreviare e risparmiare spazio.",
      fieldsToDisplay: "Campi da mostrare",
      noteDragAndDrop:
        "Nota: Trascina e rilascia le righe per riordinare le statistiche visualizzate.",
      shownStatisticName: "Nome statistica mostrato",
      showStatistic: "Mostra statistica",
      statisticId: "Id statistica",
    },
    statisticsWithPeriods: {
      benchmark: "Benchmark",
      product: "Prodotto",
      nameReplacements: "Sostituisci nomi predefiniti",
      nameReplacementsTooltip:
        "Personalizza i nomi del prodotto e del benchmark nel componente. Lascia vuoto per usare i nomi esistenti. Ad esempio, usa un termine come 'Prodotto' per abbreviare e risparmiare spazio.",
      fieldsToDisplay: "Campi da mostrare",
      noteDragAndDrop:
        "Nota: Trascina e rilascia le righe per riordinare le statistiche visualizzate.",
      periodsTitle: "Periodi da mostrare",
      shownStatisticName: "Nome statistica mostrato",
      showStatistic: "Mostra statistica",
      statisticId: "Id statistica",
      periods: {
        1: "1M",
        3: "3M",
        6: "6M",
        ytd: "YTD",
        12: "1A",
        36: "3A",
        60: "5A",
        84: "7A",
        120: "10A",
        max: "MAX",
      },
    },
    holdingsTable: {
      aggregateHoldings: "Aggrega posizioni",
      aggregateHoldingsTooltip:
        "Aggrega il valore e il peso delle posizioni che condividono lo stesso 'Holding name', 'Isin' e 'Currency'. Tutte le altre proprietà sono prese dalla posizione con il peso più alto nel gruppo. Puoi controllare questo raggruppamento nella sezione 'Regolazione dati posizioni' → 'Sovrascrivi' modificando uno qualsiasi di questi tre campi.",
      fieldsToDisplay: "Campi da mostrare",
      lagRule: "Regola di ritardo dati",
      lagRuleTooltip:
        "Puoi selezionare se vuoi ritardare i dati mostrati su questo componente di un certo periodo. Ad esempio, un ritardo di due fine mese significa che mostrerai gli ultimi dati disponibili di due mesi fa, alla fine del mese. Se sei al 15 gennaio 2025, questo significa che i dati visualizzati sarebbero al massimo del 30 novembre 2024.",
      showHeader: "Mostra intestazione",
      showHoldingsCount:
        "Mostra « X posizioni su Y » quando non vengono mostrate tutte le posizioni",
      showTotal: "Mostra totale",
      numHoldings: {
        title: "Numero di posizioni da mostrare",
        tooltip:
          "Se lasci questo campo vuoto, verranno mostrati tutti i dati disponibili per le posizioni del prodotto.",
      },
      holdingsToIgnore: {
        title: "Posizioni da ignorare",
        holdingsMultiselect: {
          placeholder: "Seleziona posizioni da ignorare",
          selectLabel: "Premi invio per selezionare",
          deselectLabel: "Premi invio per rimuovere",
          selectedLabel: "Selezionato",
          limitText: (ctx) => `e altre ${ctx.named("count")}`,
        },
      },
      holdingsToIgnoreContainText: {
        title: "Ignora le posizioni il cui nome contiene",
        placeholder: "es. Cassa, Altri",
      },
      propertyFilters: {
        property: "Proprietà",
        multiSelect: {
          placeholder: "Seleziona valori",
          selectLabel: "Premi invio per selezionare",
          deselectLabel: "Premi invio per rimuovere",
          selectedLabel: "Selezionato",
          limitText: (ctx) => `e altri ${ctx.named("count")}`,
        },
      },
      lagRuleOptions: {
        noLag: "Nessun ritardo (usa ultimi dati)",
        oneMonthEnd: "Dati fine mese precedente",
        twoMonthEnd: "Dati fine mese di due mesi fa",
      },
      displayOrder: "Ordine di visualizzazione",
      sortOptions: {
        alphabeticallyAscending: "Nome della posizione (A → Z)",
        alphabeticallyDescending: "Nome della posizione (Z → A)",
        weightAscending: "Peso (Basso → Alto)",
        weightDescending: "Peso (Alto → Basso)",
      },
      customizeTable: "Personalizza tabella",
      addColumn: "Aggiungi colonna",
      columnWithIndex: (ctx) => `Colonna ${ctx.named("idx")}`,
    },
  },
  extras: {
    changeRoles: {
      changeRoles: "Cambia ruoli",
      notify: {
        errorText: "Nessun ruolo aggiornato. Motivo: ",
        successText: "Ruoli utente aggiornati",
      },
    },
    deleteGenericComponent: {
      delete: "Elimina",
      deleteAllComponents: "Elimina tutti i componenti",
      deleteOnlyThisComponent: "Elimina solo questo componente",
      deleting: "Eliminazione in corso...",
      deleteSuccess: "Eliminazione avvenuta con successo.",
      view: "Vista",
      shareClass: "Classe di quote",
      textIsNotLinked:
        "Stai per eliminare definitivamente un componente generico. Questa azione non può essere annullata. Conferma di voler procedere con l'eliminazione.",
      textIsLinkedFirstPart:
        "Stai per eliminare definitivamente un componente generico. Questa azione non può essere annullata. Nota che questo componente è collegato allo stesso componente nei seguenti: ",
      textIsLinkedSecondPart:
        "Conferma di voler procedere con l'eliminazione e decidi se desideri eliminare solo il componente corrente o se desideri eliminare questo componente e tutti i componenti collegati.",
      title: (ctx) => `Eliminazione permanente di ${ctx.named("componentId")}`,
    },
    deleteUser: {
      button: "Elimina",
      dialog: {
        confirm: "Elimina utente",
        text: "Sei sicuro di voler eliminare definitivamente questo utente?",
        title: "Elimina utente",
      },
      notify: {
        errorText: "Eliminazione utente fallita.",
        successText: "L'utente è stato eliminato.",
      },
    },
    downloadLastFactsheet: {
      downloadLastFactsheet: "Scarica ultimo factsheet",
      downloadingLastFactsheet: "Scaricamento in corso...",
      needLogin: {
        text: "Per scaricare questo documento, devi essere autenticato.",
        title: "Devi essere autenticato",
      },
    },
    manualVerifyEmail: {
      forceVerification: "Forza verifica email",
      verified: "Email verificata",
      notify: {
        errorText: "Verifica forzata email fallita.",
        successText: "L'email dell'utente è stata verificata manualmente.",
      },
    },
    riskProfile: {
      higherRisk: "Rischio più alto",
      lowerRisk: "Rischio più basso",
    },
  },
  graphs: {
    logScale: "Scala logaritmica",
    notEnoughData:
      "Dati insufficienti per tracciare questo grafico, seleziona un intervallo di date più ampio.",
    needMoreData:
      "Per calcolare questa metrica è necessaria una certa quantità di dati all'inizio. Allarga l'intervallo temporale per accedere a questa metrica.",
  },
  holdingDataAdjustments: {
    categorise: {
      addCategory: {
        button: "Aggiungi categoria",
        prompt: {
          category: "Categoria",
          product: "Prodotto",
          property: "Proprietà",
          title: "Aggiungi una categoria",
          value: "Valore",
          valueAlreadyHasCategory: "Questo valore è già assegnato a una categoria.",
        },
      },
      exportCategories: {
        button: "Esporta categorie in CSV",
        buttonTooltip: "Scarica le mappature delle categorie visualizzate come file CSV.",
      },
      importCategories: {
        button: "Importa categorie da CSV",
        buttonTooltip: "Importa un file CSV per aggiornare le mappature delle categorie in massa.",
        importPrompt: {
          buttonCancel: "Annulla",
          buttonImport: "Importa",
          text: "Carica un file CSV formattato correttamente per aggiornare le tue mappature. Ti consigliamo di esportare prima la mappatura corrente per verificare la struttura delle colonne. Puoi caricare un file parziale contenente solo righe nuove o modificate; i dati non menzionati non verranno modificati.",
          title: "Importa categorie via CSV",
        },
        importErrorsPrompt: {
          close: "Chiudi",
          selectErrorType: "Seleziona tipo di errore:",
          title: "Errori validazione CSV",
          columns: {
            firstRow: "Prima riga",
            productName: "Nome prodotto",
            property: "Proprietà",
            rowIndex: "Indice riga",
            value: "Valore",
          },
          mismatchedColumn: {
            missingExpectedColumns: "Le seguenti colonne richieste mancano:",
            notExpectedColumns: "Sono state trovate le seguenti colonne impreviste:",
            title: "Discrepanza colonne",
            text: 'Assicurati che l\'intestazione del CSV contenga le seguenti colonne: "product_name, property, value, category".',
          },
          nonExistentProductName: {
            title: "Nome prodotto sconosciuto",
            text: "Assicurati che tutti i nomi dei prodotti esistano.",
          },
          invalidPropertyForProductName: {
            title: "Proprietà non valida per il prodotto",
            text: 'Alcune proprietà non sono disponibili per i prodotti selezionati. Rimuovile o rivedile nella scheda "Dati Posizioni" sotto la sezione "Prodotti" nel pannello di amministrazione.',
          },
          duplicatedCategory: {
            title: "Categoria duplicata per un valore",
            text: "Rimuovi le voci di categoria duplicate per lo stesso valore.",
          },
          papaparseMissingQuotes: {
            title: "Virgolette non chiuse",
            text: "L'analisi del CSV è fallita perché una stringa tra virgolette non è stata chiusa correttamente. Controlla le virgolette di chiusura mancanti nei tuoi dati.",
          },
          papaparseUndetectableDelimiter: {
            title: "Delimitatore non rilevabile",
            text: "L'analisi del CSV è fallita. Nessun delimitatore comune è stato rilevato. Assicurati che il file utilizzi coerentemente un unico delimitatore, tipicamente una virgola o un punto e virgola.",
          },
          papaparseTooFewFields: {
            title: "Campi insufficienti",
            text: "L'analisi del CSV è fallita. Alcune righe hanno meno dei 4 campi richiesti. Verifica la struttura del tuo file.",
          },
          papaparseTooManyFields: {
            title: "Troppi campi",
            text: "L'analisi del CSV è fallita. Alcune righe hanno più dei 4 campi previsti. Verifica la struttura del tuo file.",
          },
        },
      },
      saveCategories: {
        button: "Salva tutte le modifiche",
        saveSuccess: "Categorie dati posizioni salvate con successo.",
        updateWarningPrompt: {
          title: "Impatto del salvataggio modifiche",
          text: "Stai per salvare la categorizzazione dopo aver modificato una o più righe rimuovendo o aggiornando la loro categoria. Se le categorie interessate hanno traduzioni salvate, tali traduzioni potrebbero essere eliminate — a meno che la categoria esista ancora per lo stesso prodotto attraverso un altro valore. Inoltre, se queste categorie sono state utilizzate per sovrascrivere i componenti delle posizioni, anche quelle sovrascritture verranno rimosse — a meno che la categoria esista ancora per lo stesso prodotto attraverso un altro valore.",
        },
      },
    },
    translate: {
      exportTranslations: {
        button: "Esporta traduzioni in CSV",
        buttonTooltip: "Scarica le mappature delle traduzioni visualizzate come file CSV.",
      },
      importTranslations: {
        button: "Importa traduzioni da CSV",
        buttonTooltip: "Importa un file CSV per aggiornare le mappature delle traduzioni in massa.",
        importPrompt: {
          buttonCancel: "Annulla",
          buttonImport: "Importa",
          text: "Carica un file CSV formattato correttamente per aggiornare le tue mappature. Ti consigliamo di esportare prima la mappatura corrente per verificare la struttura delle colonne. Puoi caricare un file parziale contenente solo righe nuove o modificate; i dati non menzionati non verranno modificati.",
          title: "Importa traduzioni via CSV",
        },
        importErrorsPrompt: {
          close: "Chiudi",
          selectErrorType: "Seleziona tipo di errore:",
          title: "Errori validazione CSV",
          columns: {
            firstRow: "Prima riga",
            language: "Lingua",
            productName: "Nome prodotto",
            property: "Proprietà",
            rowIndex: "Indice riga",
            category: "Categoria",
          },
          mismatchedColumn: {
            missingExpectedColumns: "Le seguenti colonne richieste mancano:",
            notExpectedColumns: "Sono state trovate le seguenti colonne impreviste:",
            title: "Discrepanza colonne",
            text: (ctx) =>
              `Assicurati che l'intestazione del CSV contenga le seguenti colonne: ${ctx.named("expectedColumns").join(", ")}.`,
          },
          nonExistentProductName: {
            title: "Nome prodotto sconosciuto",
            text: "Assicurati che tutti i nomi dei prodotti esistano.",
          },
          invalidPropertyForProductName: {
            title: "Proprietà non valida per il prodotto",
            text: 'Alcune proprietà non sono disponibili per i prodotti selezionati. Rimuovile o rivedile nella scheda "Dati Posizioni" sotto la sezione "Prodotti" nel pannello di amministrazione.',
          },
          duplicatedTranslations: {
            title: "Traduzioni duplicate per un valore",
            text: "Rimuovi le voci di traduzione duplicate per lo stesso valore.",
          },
          invalidCategoryForProductNameAndProperty: {
            title: "Categoria non valida per proprietà del prodotto",
            text: "La categoria selezionata non esiste per il prodotto di questa proprietà. Verifica le categorie consentite per la proprietà data.",
          },
          invalidTranslationLangForProductName: {
            title: "Lingua non disponibile per il prodotto",
            text: "Non puoi fornire una traduzione in una lingua che il prodotto non è configurato per supportare. Esporta il CSV e controlla una riga per questo prodotto per vedere le lingue disponibili.",
          },
          papaparseMissingQuotes: {
            title: "Virgolette non chiuse",
            text: "L'analisi del CSV è fallita perché una stringa tra virgolette non è stata chiusa correttamente. Controlla le virgolette di chiusura mancanti nei tuoi dati.",
          },
          papaparseUndetectableDelimiter: {
            title: "Delimitatore non rilevabile",
            text: "L'analisi del CSV è fallita. Nessun delimitatore comune è stato rilevato. Assicurati che il file utilizzi coerentemente un unico delimitatore, tipicamente una virgola o un punto e virgola.",
          },
          papaparseTooFewFields: {
            title: "Campi insufficienti",
            text: "L'analisi del CSV è fallita. Ogni riga dovrebbe avere lo stesso numero di colonne delle intestazioni. Attualmente, alcune righe hanno meno colonne del previsto. Controlla la struttura del tuo file.",
          },
          papaparseTooManyFields: {
            title: "Troppi campi",
            text: "L'analisi del CSV è fallita. Ogni riga dovrebbe avere lo stesso numero di colonne delle intestazioni. Attualmente, alcune righe hanno più colonne del previsto. Controlla la struttura del tuo file.",
          },
        },
      },
      saveTranslations: {
        button: "Salva tutte le modifiche",
        saveSuccess: "Traduzioni dati posizioni salvate con successo.",
      },
    },
    override: {
      exportOverrides: {
        button: "Esporta sovrascritture in CSV",
        buttonTooltip: "Scarica le mappature delle sovrascritture visualizzate come file CSV.",
      },
      importOverrides: {
        button: "Importa sovrascritture da CSV",
        buttonTooltip:
          "Importa un file CSV per aggiornare le mappature delle sovrascritture in massa.",
        importPrompt: {
          buttonCancel: "Annulla",
          buttonImport: "Importa",
          text: "Carica un file CSV formattato correttamente per aggiornare le tue mappature. Ti consigliamo di esportare prima la mappatura corrente per verificare la struttura delle colonne. Puoi caricare un file parziale contenente solo righe nuove o modificate; i dati non menzionati non verranno modificati.",
          title: "Importa sovrascritture via CSV",
        },
        importErrorsPrompt: {
          close: "Chiudi",
          selectErrorType: "Seleziona tipo di errore:",
          title: "Errori validazione CSV",
          columns: {
            category: "Categoria",
            currency: "Valuta",
            firstRow: "Prima riga",
            holdingName: "Nome posizione",
            isin: "ISIN",
            productName: "Nome prodotto",
            property: "Proprietà",
            rowIndex: "Indice riga",
          },
          mismatchedColumn: {
            missingExpectedColumns: "Le seguenti colonne richieste mancano:",
            notExpectedColumns: "Sono state trovate le seguenti colonne impreviste:",
            title: "Discrepanza colonne",
            text: (ctx) =>
              `Assicurati che l'intestazione del CSV contenga le seguenti colonne: ${ctx.named("expectedColumns").join(", ")}.`,
          },
          unknownProductName: {
            title: "Nome prodotto sconosciuto",
            text: "Alcuni nomi di prodotti nel file non corrispondono a prodotti esistenti. Controlla errori di battitura o nomi non validi.",
          },
          invalidPropertyForProductName: {
            title: "Proprietà non valida per il prodotto",
            text: 'Alcune proprietà non sono disponibili per i prodotti selezionati. Rimuovile o rivedile nella scheda "Dati Posizioni" sotto la sezione "Prodotti" nel pannello di amministrazione.',
          },
          unknownOverrideCategory: {
            title: "Categoria sovrascrittura sconosciuta",
            text: "Uno o più valori di sovrascrittura fanno riferimento a una categoria inesistente per il prodotto e la proprietà specificati. Verifica le categorie disponibili prima di importare.",
          },
          invalidConstituent: {
            title: "Chiave componente non valida",
            text: "Alcune righe fanno riferimento a componenti (Nome Prodotto, Nome Posizione, ISIN, Valuta) che non esistono. Rimuovi o correggi queste voci.",
          },
          duplicateConstituent: {
            title: "Sovrascritture duplicate",
            text: "Sono state trovate voci di sovrascrittura multiple per lo stesso componente (Nome Prodotto, Nome Posizione, ISIN, Valuta). Mantieni solo una voce per componente.",
          },
          papaparseMissingQuotes: {
            title: "Virgolette non chiuse",
            text: "L'analisi del CSV è fallita perché una stringa tra virgolette non è stata chiusa correttamente. Controlla le virgolette di chiusura mancanti nei tuoi dati.",
          },
          papaparseUndetectableDelimiter: {
            title: "Delimitatore non rilevabile",
            text: "L'analisi del CSV è fallita. Nessun delimitatore comune è stato rilevato. Assicurati che il file utilizzi coerentemente un unico delimitatore, tipicamente una virgola o un punto e virgola.",
          },
          papaparseTooFewFields: {
            title: "Campi insufficienti",
            text: "L'analisi del CSV è fallita. Ogni riga dovrebbe avere lo stesso numero di colonne delle intestazioni. Attualmente, alcune righe hanno meno colonne del previsto. Controlla la struttura del tuo file.",
          },
          papaparseTooManyFields: {
            title: "Troppi campi",
            text: "L'analisi del CSV è fallita. Ogni riga dovrebbe avere lo stesso numero di colonne delle intestazioni. Attualmente, alcune righe hanno più colonne del previsto. Controlla la struttura del tuo file.",
          },
        },
      },
      saveOverrides: {
        button: "Salva tutte le modifiche",
        saveSuccess: "Sovrascritture dati posizioni salvate con successo.",
      },
    },
  },
  images: {
    uploadImage: {
      darkening: "Oscuramento",
      file: "File",
      noFile: "Nessun file",
      noImage: "Nessuna immagine",
      promptTitle: "Carica nuova immagine",
      selectFile: "Seleziona file",
      selectNewImage: "Seleziona nuova immagine",
      submit: "Invia",
      submitting: "Invio in corso...",
      errorTitleTooLarge: "Immagine troppo grande",
      errorMessageTooLarge:
        "L'immagine è troppo grande. Seleziona un'altra immagine con una dimensione inferiore a 30 MB.",
      warningTitleVeryLarge: "Immagine molto grande",
      warningMessageVeryLarge:
        "L'immagine è molto grande. Rallenterà il caricamento delle pagine che mostrano questa immagine. Per prestazioni ottimali, si consiglia di utilizzare immagini inferiori a 10 MB.",
    },
  },
  linkPrompt: {
    componentLinkedTo: "Questo componente è collegato a:",
    currentView: "Vista corrente",
    currentShareClass: "Classe di quote corrente",
    linkThroughViewsTooltip:
      'Abilitare questa funzione crea una connessione sincronizzata tra componenti attraverso più viste. Ad esempio, collegando le viste "Scheda informativa" e "Panoramica" si garantisce che qualsiasi modifica a un componente condiviso venga aggiornata simultaneamente su entrambe le viste. Importante: Il contenuto del componente collegato viene duplicato dalla vista sorgente che stai attualmente modificando. Se avvii il collegamento mentre modifichi il componente "descrizione" della vista "Scheda informativa", il componente "descrizione" in "Scheda informativa" viene copiato nella "Panoramica" e quindi sovrascriverà il componente "descrizione" della "Panoramica".',
    linkThroughShareClassesTooltip:
      'Abilitare questa funzione crea una connessione sincronizzata tra componenti attraverso più classi di quote. Ad esempio, collegando "Mio Prodotto Classe A" e "Mio Prodotto Classe B" si garantisce che qualsiasi modifica a un componente condiviso venga aggiornata simultaneamente su entrambe le classi di quote. Importante: Il contenuto del componente collegato viene duplicato dalla vista sorgente che stai attualmente modificando. Se avvii il collegamento mentre modifichi il componente "descrizione" della vista "Mio Prodotto Classe A", il componente "descrizione" in "Mio Prodotto Classe A" viene copiato in "Mio Prodotto Classe B" e quindi sovrascriverà il componente "descrizione" di "Mio Prodotto Classe B".',
    linkThroughShareClassesForbiddenCrossProductTooltip:
      "Questo componente mostra i dati di tutte le classi di quote, quindi è sempre collegato a tutte le classi di quote del prodotto. Per questo motivo non è possibile scollegare le singole classi di quote; possono essere rimossi solo i collegamenti ad altre viste.",
    linkedWithViews: "Collegato con le seguenti viste",
    linkedWithShareClasses: "Collegato con le seguenti classi di quote",
    view: "Vista",
    shareClass: "Classe di quote",
    title: (ctx) => `Modifica collegamento di ${ctx.named("componentId")}`,
    unlink: "Scollega",
    unlinking: "Scollegamento...",
    unsavedChangesAlert: "Hai modifiche non salvate. Se esci senza salvare, andranno perse.",
    confirmSaveDialog: {
      computingNewLinks: "Calcolo nuovi collegamenti...",
      onceLinked:
        "Una volta collegato, quando viene applicata una modifica a un componente in una qualsiasi di quelle posizioni (inclusa quella attuale), tutti gli altri componenti collegati verranno aggiornati allo stesso modo. Conferma di voler procedere con il salvataggio.",
      overwrittenExistingComponent: "Sovrascrittura di un componente con lo stesso id",
      overwrittenExistingComponentTooltip: (ctx) =>
        `Attenzione: Esiste già un componente con ID '${ctx.named(
          "componentId"
        )}' in questa posizione, quindi verrà sovrascritto da questo componente se lo colleghi.`,
      title: "Conferma salvataggio nuovi collegamenti",
      youAreAboutToLink:
        "Stai per collegare il componente corrente con i componenti nelle seguenti posizioni:",
    },
    overviewStyle: {
      title: "Modifica collegamenti nello stile della panoramica",
      saveSuccess: "L'aggiornamento dei collegamenti di stile è avvenuto con successo.",
    },
    reportFooter: {
      title: "Modifica collegamenti nel piè di pagina del report",
      saveSuccess: "L'aggiornamento dei collegamenti del piè di pagina è avvenuto con successo.",
    },
    reportHeader: {
      title: "Modifica collegamenti nell'intestazione del report",
      saveSuccess: "L'aggiornamento dei collegamenti dell'intestazione è avvenuto con successo.",
    },
    reportStyle: {
      title: "Modifica collegamenti nello stile del report",
      saveSuccess: "L'aggiornamento dei collegamenti di stile è avvenuto con successo.",
    },
    notify: {
      linkSaveSuccess: (ctx) =>
        `L'aggiornamento del collegamento di '${ctx.named("componentId")}' è avvenuto con successo.`,
    },
    multiselect: {
      placeholderShareClasses: "Seleziona classi di quote da collegare",
      placeholderViews: "Seleziona viste da collegare",
      selectLabel: "Premi invio per selezionare",
      deselectLabel: "Premi invio per rimuovere",
      selectedLabel: "Selezionato",
    },
    overviewHeader: {
      title: "Modifica collegamento dell'intestazione panoramica",
      saveSuccess: "L'aggiornamento del collegamento dell'intestazione è avvenuto con successo.",
    },
  },
  pricesManagement: {
    addData: "Aggiungi dati",
    autoDataUpdate: "I tuoi dati vengono aggiornati automaticamente.",
    date: "Data",
    datePlaceholder: "AAAA-MM-GG",
    dateValidationError: "Non puoi aggiungere una data che ha già un valore.",
    exportCsvButton: "Esporta come CSV",
    importCsvButton: "Importa da CSV",
    launchPriceUpdateButton: "Avvia aggiornamento",
    launchPriceUpdateTooltip:
      "Cliccando su questo pulsante si forza un aggiornamento recuperando i dati più recenti dalla fonte normalmente usata per l'aggiornamento automatico giornaliero (se questi dati vengono aggiornati automaticamente). I dati possono richiedere alcuni minuti per essere recuperati e aggiornati.",
    launchPriceUpdateRunningTooltip: "I prezzi sono attualmente in fase di recupero.",
    loadingData: "Caricamento dati...",
    price: "Prezzo",
    priceAdj: "Prezzo (rettificato)",
    priceAdjTooltip:
      "Generalmente, per prezzi rettificati si intendono prezzi corretti per dividendi, frazionamenti e altri eventi. Se non fornito, si presume che sia uguale al prezzo.",
    priceAdjTooltipTable:
      "Generalmente, per prezzi rettificati si intendono prezzi corretti per dividendi, frazionamenti e altri eventi.",
    refreshButton: "Aggiorna",
    removeData: "Rimuovi dati",
    benchmarks: {
      noBenchmark: "Nessun benchmark disponibile per questo prodotto.",
    },
    dialog: {
      removeData: {
        title: "Rimuovi un punto dati",
        text: "Stai per rimuovere completamente un punto dati. Sei sicuro?",
      },
    },
    importCsvText: {
      para1:
        "Il file di input deve essere in formato CSV, con due o tre colonne e una riga di intestazione.",
      para2:
        "La prima colonna deve consistere in date, e la seconda colonna deve consistere in numeri (il prezzo alla data corrispondente). Una terza colonna è opzionale e, se fornita, deve consistere in numeri corrispondenti al prezzo rettificato; se non viene fornita, si presume che i prezzi rettificati siano uguali ai prezzi.",
      para3:
        "Assicurati che il tuo CSV sia valido per evitare problemi durante la lettura e l'analisi dei dati.",
    },
    notify: {
      dateUsedMultipleTimeError:
        "Ci sono prezzi multipli associati a una data. Devi assicurarti che ogni data abbia un unico prezzo assegnato.",
      launchSuccessText:
        "L'aggiornamento dei prezzi è stato avviato con successo. Aggiorna tra qualche minuto per vedere i risultati.",
      launchErrorText: "Errore durante l'avvio dell'aggiornamento dei prezzi, contattaci.",
      nanFound:
        "Sono stati trovati alcuni valori vuoti, assicurati che tutte le righe e colonne contengano un valore.",
      numberFormatError:
        'Almeno uno dei numeri ha un formato non riconosciuto. Idealmente, non dovresti usare alcun separatore per le migliaia e usare il punto come separatore decimale poiché questo è il formato previsto. Ad esempio, "102.12", "1380.25", "18.952", ...',
      saveErrorText: "Errore durante l'aggiornamento dei prezzi, contattaci.",
      saveSuccessText: "I prezzi sono stati aggiornati con successo.",
    },
    prompt: {
      addPrice: "Aggiungi un prezzo",
      importCsv: "Importa dati da CSV",
    },
  },
  tables: {
    metricsTable: {
      na: "N/D",
      name: "Nome",
      showLess: "Mostra meno",
      showMore: "Mostra altro",
    },
    monthlyReturnsTable: {
      benchmark: "Benchmark",
      return: "Rendimento",
    },
    performanceTable: {
      computedFromTo: (ctx) =>
        `Performance calcolata dal ${ctx.named("firstDate")} al ${ctx.named("lastDate")}.`,
      notAvailableData:
        "Dati non disponibili o perché non ci sono abbastanza giorni per calcolarli, i dati non sono significativi (es. indice di Sharpe negativo), o il benchmark non è sempre disponibile durante il periodo selezionato",
    },
    holdingsTable: {
      noDataYet: "Questo componente non ha ancora dati.",
      holdingFields: {
        currency: "Valuta",
        holdingName: "Nome",
        isin: "ISIN",
        value: "Valore",
        weight: "Peso",
      },
      totalOfPortfolio: "Totale del portafoglio",
      holdingsCountSummary: (ctx) => `${ctx.named("shown")} posizioni su ${ctx.named("total")}`,
    },
    liquidityAnalysisTable: {
      noDataYet: "Questo componente non ha ancora dati.",
      description: "Descrizione",
      isin: "ISIN",
      currency: "Valuta",
      aumInLocalCurrency: (ctx) => `AUM (${ctx.named("currency")})`,
      weight: "Peso",
      lessThanOneDay: "0-1 giorno",
      twoToSevenDays: "2-7 giorni",
      eightToThirtyDays: "8-30 giorni",
      thirtyOneToNinetyDays: "31-90 giorni",
      ninetyOneToOneHundredEightyDays: "91-180 giorni",
      oneHundredEightyOneToThreeHundredSixtyFiveDays: "181-365 giorni",
      moreThanThreeHundredSixtyFiveDays: ">365 giorni",
      totalOfPortfolio: "Totale del portafoglio",
    },
  },
  thirdParty: {
    vuePhoneNumberInput: {
      countrySelectorLabel: "Codice paese",
      countrySelectorError: "Seleziona un paese",
      phoneNumberLabel: "Numero di telefono",
      example: "Esempio:",
    },
  },
  videos: {
    uploadVideo: {
      file: "File",
      noFile: "Nessun file",
      noVideo: "Nessun video",
      selectFile: "Seleziona file",
      selectNewVideo: "Seleziona nuovo video",
      errorTitleTooLarge: "Video troppo grande",
      errorMessageTooLarge:
        "Il video è troppo grande. Seleziona un altro video con una dimensione inferiore a 30 MB.",
      warningTitleVeryLarge: "Video molto grande",
      warningMessageVeryLarge:
        "Il video è molto grande. Rallenterà il caricamento delle pagine che mostrano questo video. Per prestazioni ottimali, si consiglia di utilizzare video inferiori a 10 MB.",
    },
  },
};
